import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-state",
  "use": "icon-state-usage",
  "viewBox": "0 0 1293 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1293 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-state\"><defs><style type=\"text/css\"></style></defs><path d=\"M1084.136794 103.747853c0 19.132622 5.173892 37.079559 14.174308 52.277867l-294.265108 413.911361a103.262261 103.262261 0 0 0-76.584381 14.76715L521.799405 452.446617v-2.586946a103.801209 103.801209 0 1 0-197.092948 45.271555l-204.260946 310.756889a103.801209 103.801209 0 1 0 71.033226 46.672817l199.464316-302.996051c8.784837 2.425262 17.946938 3.610945 27.486302 3.610946 25.168829 0 48.289659-9.000416 66.290491-23.929251l197.092949 126.652565a103.801209 103.801209 0 1 0 206.255049 15.359992c0-19.132622-5.227787-37.079559-14.174308-52.277867l294.426792-413.911361a103.801209 103.801209 0 0 0 123.903935-101.75321A103.962893 103.962893 0 0 0 1187.884108 0.000539a103.801209 103.801209 0 0 0-103.747314 103.747314z\" p-id=\"9290\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/state.svg
// module id = hScd
// module chunks = 5